/**
 * `localStorage` is unavailable or throws in private windows and some embedded
 * webviews, so every access goes through these helpers and degrades to a no-op.
 */

export const StorageKey = {
  theme: "wiki.theme",
  lastProvider: "wiki.lastProvider",
  sidebarWidth: "wiki.sidebarWidth",
  sidebarCollapsed: "wiki.sidebarCollapsed",
  homeTab: "wiki.homeTab",
  collectionTab: "wiki.collectionTab",
  sidebarExpanded: "wiki.sidebarExpanded",
  documentTocOpen: "wiki.documentTocOpen",
} as const;

export function readStored(key: string): string | null {
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}

export function writeStored(key: string, value: string): void {
  try {
    window.localStorage.setItem(key, value);
  } catch {
    /* storage unavailable; the preference simply does not persist */
  }
}

export function clearStored(key: string): void {
  try {
    window.localStorage.removeItem(key);
  } catch {
    /* as above */
  }
}
